import { Heading, Text, View } from '@aws-amplify/ui-react';
import { useMediaQuery } from '@mui/material';

interface AccessibilityLogoProps {
    heading?: string;
    subHeading?: string;
    description?: string;
    headingSx?: React.CSSProperties;
    subHeadingSx?: React.CSSProperties;
}

export const AccessibilityLogo = ({
    heading = 'CFRA Accessibility Chart Reader',
    subHeading = '',
    description = '',
    headingSx,
    subHeadingSx,
}: AccessibilityLogoProps) => {
    const isMobile = useMediaQuery('(max-width:999.5px)');
    const isBelow400px = useMediaQuery('(max-width:399.5px)');

    return (
        <View textAlign='center'>
            <Heading
                level={1}
                style={{
                    marginBottom: '5px',
                    fontFamily: 'GraphikBold',
                    color: isMobile ? '#fff' : '#3B99A7',
                    fontSize: isBelow400px ? '36px' : '44px',
                    marginTop: '10px',
                    letterSpacing: '-0.025em',
                    ...headingSx,
                }}>
                {heading}
            </Heading>
            {subHeading && (
                <Heading
                    level={2}
                    style={{
                        marginBottom: '0px',
                        fontFamily: 'GraphikRegular',
                        color: '#3B99A7',
                        fontSize: isBelow400px ? '24px' : '28px',
                        marginTop: '0px',
                        letterSpacing: '-0.025em',
                        ...subHeadingSx,
                    }}>
                    {subHeading}
                </Heading>
            )}
            <Text
                style={{
                    marginBottom: '1rem',
                    fontFamily: 'GraphikRegular',
                    fontSize: '15px',
                    lineHeight: '1.7em',
                    color: isMobile ? '#fff' : '#222222',
                }}>
                {description}
            </Text>
        </View>
    );
};
